import { chain } from "lodash"

const sagas = chain(require.context(".", true, /^\.\/[^/]+\/model.js/).keys())
  .map(path => path.split("/")[1])
  .map(id => require(`./${id}/model`).saga)
  .flatten()
  .filter(saga => !!saga)
  .value()

export default sagas
